import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Api } from "../../services/api";
import { Util } from "../../services/util";
import { mobilePrefixData } from "../../services/sms";

/**
 * Generated class for the BindAccountPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-bind-account",
  templateUrl: "bind-account.html",
})
export class BindAccountPage {
  loading = true;
  boundAccount = {};
  formData = {
    mobile: "",
    mobileNumber: "",
    mobilePrefix: "",
    countDown: 0,
    step: 0,
    verificationCode: "",
  };

  mobilePrefixData = mobilePrefixData;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public api: Api,
    private util: Util
  ) {}

  countdownTimer = null;

  ionViewDidEnter() {
    this.countdownTimer = setInterval(() => {
      this.formData.countDown--;
    }, 1000);
  }

  ionViewWillUnload() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  }

  doBind() {
    this.api.doBindByVerificationCode(this.getFormData()).then((data) => {
      if (data["ok"]) {
        window["UserService"]["user_center_user_id"] = data["id"];
        this.util.showToast("手机号绑定成功");
        this.navCtrl.pop();
        if (window["bindAccountCallback"]) {
          window["bindAccountCallback"]();
          window["bindAccountCallback"] = null;
        }
      }
    });
  }

  getFormData() {
    this.formData.mobile =
      this.formData.mobilePrefix.trim() + this.formData.mobileNumber.trim();
    return this.formData;
  }

  requestVerificationCode() {
    this.api.requestBindVerificationCode(this.getFormData()).then((data) => {
      if (data["ok"]) {
        this.formData.countDown = 60;
        this.formData.step = 1;
      }
    });
  }

  unbind() {
    this.util
      .confirm(
        "确定要解绑吗？<br/>解绑后，本平台购买的课程将不会再自动激活。",
        "请确认"
      )
      .then((res) => {
        if (res) {
          this.api.unbindAccount().then((data) => {
            if (data["ok"]) {
              this.util.showToast("解除绑定成功");
              window["UserService"]["user_center_user_id"] = 0;
              this.refresh();
            }
          });
        }
      });
  }

  ionViewDidLoad() {
    this.loading = true;
    this.refresh();
  }

  private refresh() {
    this.api.getAccountBindInfo().then((data) => {
      this.loading = false;
      if (data.ok) {
        this.boundAccount = data;
      } else {
        this.boundAccount = null;
      }
      window["UserService"]["user_center_user_id"] = data.id;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/bind-account/bind-account.ts